module.exports = __webpack_public_path__ + "img/diesel-locomotive-04.ac0f1315.png";